<div class="balance">
  <div class="balance__wrapper">
    <span class="caption">Ваш баланс:</span>
    <div class="balance__empty" *ngIf="!balance || reload" [ngClass]="{'reload': reload}">0000руб</div>
    <div class="balance__price" *ngIf="balance && !reload">{{balance}}руб</div>
    <div class="balance__button">
      <ui-icon (click)="submit()" *ngIf="!reload" [nameIcon]="!balance ? 'visibility_off' : 'autorenew'" [nz-tooltip]="!balance ? 'Показать баланс' : 'Обновить' "></ui-icon>
    </div>
  </div>
</div>
